import {TuningsUpdatePersiteCreateData} from '../../userway/sdk/UserWayApiClient';

export enum WidgetAddonsProperty {
  TwoColumnsLayout = 'two_columns_layout',
  Oversized = 'oversized',
  Profiles = 'profiles',
  FeaturesPattern = 'features_pattern',
}

export enum WidgetTuningsProperty {
  AccessibilityLinkEnabled = 'accessibility_link_enabled',
  AccessibilityLinkText = 'accessibility_link_text',
  AccessibilityUrl = 'accessibility_url',
  SiteName = 'site_name',
  WidgetColor = 'widget_color',
  PaidAi = 'paidAi',
  WidgetColorGradient = 'widget_color_gradient',
  WidgetHiddenForSite = 'widget_hidden_for_site',
  WidgetHiddenForMobile = 'widget_hidden_for_mobile',
  WidgetSounds = 'widget_sounds',
  WidgetIconSize = 'widget_icon_size',
  WidgetIconType = 'widget_icon_type',
  WidgetLanguage = 'widget_language',
  WidgetPosition = 'widget_position',
  WidgetPositionMobile = 'widget_position_mobile',
  WidgetCustomTrigger = 'widget_custom_trigger',
  WidgetCustomTriggerEnabled = 'widget_custom_trigger_enabled',
  SiteId = 'site_id',
  Host = 'host',
  WidgetPositionNudge = 'widget_position_nudge',
  WidgetPositionNudgeMobile = 'widget_position_nudge_mobile',
  WidgetLiveLanguageEnabled = 'widget_live_language_enabled',
  WidgetLayout = 'widget_layout',
  WidgetLstButtonEnabled = 'widget_lst_button_enabled',
  WidgetLstButtonIconType = 'widget_lst_button_icon_type',
  WidgetLstButtonType = 'widget_lst_button_type',
  WidgetGaEnabled = 'widget_ga_enabled',
}

export interface ApiRequestsDataOfTuningsAndAddons {
  type: 'ModifyMenuSettings' | 'Tunings';
  response: TuningsUpdatePersiteCreateData | {code: number};
}
